<div #ngContentRef><ng-content></ng-content></div>
<div *ngIf="!ngContentRef.hasChildNodes() && gridOptions.gridState && gridOptions.dataLength && 
    gridOptions.gridState.currentPage && gridOptions.gridState.pageSize">
    <div class="fc-sticky-bar">
        <div class="ag-grid-responsive-paging-control">
            <div class="ag-grid-responsive-paging-detail">
                <span class="detail">Records per page: {{ gridOptions.gridState.pageSize }}</span>
                <span class="detail">{{ gridOptions.getPageDetail && gridOptions.getPageDetail() }}</span>
            </div>
            <div class="ag-grid-responsive-paging">
                <button id="ag-grid-paging-prev"
                        [attr.disabled]="gridOptions.gridState.currentPage <= 1 ? true : null"
                        (click)="gridOptions.showPage && gridOptions.showPage(gridOptions.gridState.currentPage - 1)"></button>
                <button id="ag-grid-paging-next"
                        [attr.disabled]="gridOptions.gridState.currentPage === (gridOptions.getPageNumbers && gridOptions.getPageNumbers() || []).length ? true : null"
                        (click)="gridOptions.showPage && gridOptions.showPage(gridOptions.gridState.currentPage + 1)"></button>

                <div class="ag-grid-paging-dropdown-wrapper">
                    <span class="ag-grid-paging-dropdown-label">Go To:</span>

                    <button class="ag-grid-paging-dropdown-button"
                            (click)="gridOptions.isDropDownOpen = !gridOptions.isDropDownOpen">
                        {{gridOptions.gridState.currentPage}}
                        <svg xmlns="http://www.w3.org/2000/svg" fill="grey" viewBox="0 0 22 22">
                            <path d="m11.998 17 7-8h-14z"/>
                        </svg>
                    </button>

                    <div class="ag-grid-paging-dropdown-scroller"
                         *ngIf="gridOptions.isDropDownOpen">
                        <div class="ag-grid-paging-dropdown-item"
                             (click)="gridOptions.showPage && gridOptions.showPage(pageNumber); gridOptions.isDropDownOpen = false"
                             *ngFor="let pageNumber of (gridOptions.getPageNumbers && gridOptions.getPageNumbers())">
                            <span>{{ pageNumber }}</span>
                        </div>
                    </div>

                    <div class="ag-grid-paging-dropdown-backdrop"
                         *ngIf="gridOptions.isDropDownOpen"
                         (click)="gridOptions.isDropDownOpen = false"></div>
                </div>
            </div>
        </div>
    </div>
</div>